import { type EditUploadContentType } from '../types';

const MIME_TYPE_TO_EXTENSION = new Map<EditUploadContentType, string[]>([
  ['image/apng', ['apng']],
  ['image/avif', ['avif']],
  ['image/bmp', ['bmp']],
  ['image/gif', ['gif']],
  ['image/heic', ['heic']],
  ['image/heif', ['heif']],
  ['image/jpeg', ['jpeg', 'jpg']],
  ['image/png', ['png']],
  ['image/svg+xml', ['svg']],
  ['image/tiff', ['tif', 'tiff']],
  ['image/webp', ['webp']],
]);

/**
 * All content types accepted by the canvas edit upload endpoint.
 * Typed against the SDK's EditUploadContentType for compile-time safety —
 * if the SDK adds or removes a type, TypeScript will flag the mismatch.
 * SVG is added via @ts-expect-error until EditUploadContentType includes it.
 */
export const ACCEPTED_UPLOAD_MIME_TYPES: readonly EditUploadContentType[] = Array.from(MIME_TYPE_TO_EXTENSION.keys());

export function isAcceptedMimeType(mimeType: string): mimeType is EditUploadContentType {
  return ACCEPTED_UPLOAD_MIME_TYPES.some((type) => type === mimeType);
}

/**
 * File extensions the canvas can render as image nodes.
 * Derived from {@link MIME_TYPE_TO_EXTENSION} so the two never drift.
 */
export const CANVAS_SUPPORTED_IMAGE_EXTENSIONS: ReadonlySet<string> = new Set(
  Array.from(MIME_TYPE_TO_EXTENSION.values()).flat(),
);
